import React from 'react';
import './App.css';
import Login from './Screens/Account/Login';
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Login from "./Screens/Login.js";
// import Register from "./Screens/Register.js";

function App() {
  return (
    <div className="App">
      <Login />
    </div>
  );
}

export default App;